import { PropsWithChildren } from 'react';

import { Box, BoxProps, Button, Popover, TdProps, useTableStyles } from '@oaknorth/component-core-v2';
import { InterpolateElement } from '@oaknorth/util-intl';

export interface TablePopoverCellProps extends TdProps {
  popoverTitle: string | InterpolateElement;
  cellContentsProps?: BoxProps;
}

export function TablePopoverCell({
  cellContentsProps,
  isNumeric,
  textAlign,
  border,
  popoverTitle,
  children,
}: PropsWithChildren<TablePopoverCellProps>) {
  const tableStyles = useTableStyles();

  return (
    <Box
      css={tableStyles.td}
      textAlign={textAlign || (isNumeric ? 'right' : undefined)}
      border={border}
      {...cellContentsProps}
    >
      <Popover
        trigger={
          <Button fontWeight="normal" variant="link" padding="0">
            {popoverTitle}
          </Button>
        }
        body={children}
      />
    </Box>
  );
}
